import { Button } from "primereact/button";
import { JVDate } from "../../shared/JVDate";
import { JVDropdown } from "../../shared/JVDropdown";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { IBranchMastDropdown, ICompanyMastDropdown } from "../../models/IDropdown";
import { Fetch } from "../../shared/Fetch";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toDate } from "date-fns";

interface IProps{
    filters: any,
    setFilters: (filters: any)=> void,
}

export interface IEmptyFilter{
    fromDate?: Date,
    toDate?: Date,
    company?: number | null,
    branch?: number | null,
}

let today = new Date();

export const EmptyFilter: IEmptyFilter = {
    fromDate: today,
    toDate: today,
    company: null,
    branch: null,
}

const schema = yup.object({
    fromDate: yup.date().nullable(),
    toDate: yup.date().nullable(),
    company: yup.number().nullable(),
    branch: yup.number().nullable(),
});

export const Filter=(props: IProps)=>{
    const [companies,setCompanies] = useState<Array<any>>([]);
    const [branches,setBranches] = useState<Array<any>>([]);

    const { control, handleSubmit, reset, watch } = useForm<IEmptyFilter>({
        resolver: yupResolver(schema),
        defaultValues: props.filters,
        shouldFocusError: false
    });

    const loadCompany = async () => {
        const response = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    }

    const loadBranch = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        const response = await Fetch("Dropdown/filterBranchList", "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    }

    useEffect(()=>{
        const subscription = watch((value, {name, type}) => {

            if (name === "company") {
                if (value.company != 0 && value.company != null){
                    loadBranch(value.company);
                } else {
                    if (value.company === 0 && value.company != null){
                        loadBranch(control._formValues.company);
                    }
                }
            }
        });

        return () => subscription.unsubscribe();
    },[watch]);

    useEffect(()=>{
        loadCompany();
        loadBranch();
    },[]);

    const onSubmit=(data: any)=>{
        props.setFilters(data);
        console.log(data);
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

            <JVDate column={6} label="From Date" control={control} name="fromDate" />
            <JVDate column={6} label="To Date" control={control} name="toDate" />
            <JVDropdown column={6} label="Company" control={control} name="company" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
            <JVDropdown column={6} label="Branch Sales" control={control} name="branch" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Sales Branch" />

            <div style={{ margin: '10px 0', width: '100%' }}></div>

            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => { reset(EmptyFilter) }} type="button"></Button>
            </div>
        </form>
    );
}